import { jsx as _jsx } from "react/jsx-runtime";
import { NativeFullScreenLayout } from '~/components/NativeFullScreenLayout/NativeFullScreenLayout';
export const BootRetryScreen = (param)=>{
    let { onRetry, biName, title = 'Unable to connect', body = 'Check your internet connection and try again.', retryLabel = 'Retry', caption } = param;
    return /*#__PURE__*/ _jsx(NativeFullScreenLayout, {
        title: title,
        body: body,
        caption: caption,
        action: {
            label: retryLabel,
            onClick: onRetry,
            biName
        }
    });
};
